import { useEffect, useRef, useState } from "react";

export const useTooltipHoverActions = ( disableHover=false ) => {
  const [ hover, setHover ] = useState(false);
  
  const timeout = useRef();
  const anchor = useRef(null);

  const handleHoverIn = () => {
    if (!disableHover) setHover(true);
  };

  const handleHoverOut = () => setHover(false);

  const handlePopupClose = () => {
    if (hover) timeout.current = setTimeout(() => setHover(false), 200);
  };

  const handleTimeoutClear = () => {
    if (timeout.current) clearTimeout(timeout.current);
  };

  useEffect(() => {
    handleTimeoutClear();
  }, [hover]);

  return {
    anchor,
    hover: disableHover ? false : hover,
    handleHoverIn,
    handleHoverOut,
    handlePopupClose,
    handleTimeoutClear,
  };
};
